import type { BigDecimal, MonetaryAmount, PropifyEntity } from '@/domain/base';
import type { PetPolicy } from '@/domain/pet-policies';
import type { Property, PropertyImage } from '@/domain/properties';

export enum ListingStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  COMING_SOON = 'COMING_SOON',
  HOLD = 'HOLD',
}

export interface School {
  name: string;
  rating_band: string;
  level: string;
  distance: BigDecimal;
  'web-site': string;
  'overview-url': string;
}

export interface Unit extends PropifyEntity {
  property: Property;
  readyDate?: string;
  listedRent?: MonetaryAmount;
  listingStatus?: ListingStatus;
  floorPlanId: number;
  petPolicy?: PetPolicy;
  images?: PropertyImage[];
  amenityNames?: string[];
  bedroomCount: number;
  fullBathroomCount?: number;
  halfBathroomCount?: number;
  quarterBathroomCount?: number;
  threeQuarterBathroomCount?: number;
  squareFeet: number;
  floorPlanName: string;
  foreignShowingLink?: string;
}
